import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'ui-components/components/button';
import InventoryLevelsModal from './inventory-levels-modal';
import style from './style.module.less';
import classnames from 'classnames';

const InventoryModalOpener = ({ aggregateInventoryCounts, hasFaultyConnection, name, children }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const onOpenModal = useCallback(() => {
    setIsModalOpen(true);
  }, []);

  const onCloseModal = useCallback(() => {
    setIsModalOpen(false);
  }, []);

  return (
    <>
      <Button
        className={classnames(style['available-quantity'], {
          [style['show-warning']]: hasFaultyConnection,
        })}
        onClick={onOpenModal}
        theme='link'
      >
        {children}
      </Button>
      {isModalOpen && <InventoryLevelsModal aggregateInventoryCounts={aggregateInventoryCounts} name={name} onCloseModal={onCloseModal} />}
    </>
  );
};

InventoryModalOpener.propTypes = {
  aggregateInventoryCounts: PropTypes.shape({
    availableQuantity: PropTypes.number,
    committedQuantity: PropTypes.number,
    excludedQuantity: PropTypes.number,
    hasValidInventory: PropTypes.bool,
    connectionCounts: PropTypes.arrayOf(
      PropTypes.shape({
        availableQuantity: PropTypes.number,
        isConnectionIncluded: PropTypes.bool,
        connectionStatus: PropTypes.string,
        connectionType: PropTypes.string,
        onhandQuantity: PropTypes.number,
      }),
    ),
  }),
  hasFaultyConnection: PropTypes.bool.isRequired,
  name: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default InventoryModalOpener;
